import React from 'react';
import { RowHeaderTable, TableDistributors } from '../../components';

const Companies: React.FC = () => {
  return (
    <div>
      <div className="container-body no-padding">
        <RowHeaderTable
          name="Distribuidoras"
          navigationPath="/home/companies/create"
        />
        <TableDistributors />
      </div>
    </div>
  );
};

export default Companies;
